import React, { useContext } from "react";
import styles from "./index.module.scss";
import UserAvatar from "../../../Components/UserAvatar";
import ReplyItem from "../ReplyItem";
import ReplyEditor from "../ReplyEditor";
import useStorage from "utils/useStorage";
import { ReplyItemData } from "../../../../../service/discuss";
import { AnswerContent } from "../../context";

interface RepliesProps {
    data: ReplyItemData[];
}

export default function Replies({ data }: RepliesProps) {
    const [teacherNo] = useStorage("teacherNo");
    const [teacherName] = useStorage("teacherName");

    const { replyCount } = useContext(AnswerContent);

    return (
        <div className={styles.root}>
            <div className={styles.top}>
                <UserAvatar
                    size={40}
                    isTeacher
                    userNo={teacherNo!}
                    userName={teacherName!}
                />
                <ReplyEditor />
            </div>

            {data.length !== 0 && (
                <div className={styles.main}>
                    <div className={styles.listTop}>{replyCount}条评论</div>

                    <div className={styles.list}>
                        {data.map(item => (
                            <ReplyItem key={item.uuid} data={item} />
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
}
